<template>
    <div class="sustainability-env">
      <div class="sustainability-env-content">
          <p class="indent">La protezione dell’ambiente e l’uso efficace delle risorse naturali sono stati da sempre tra le principali priorità nello sviluppo di Alcomet. Negli ultimi anni, tutti gli investimenti tesi alla modernizzazione ed all’espansione delle capacità produttive sono stati invariabilmente accompagnati dall’installazione di moderne attrezzature antinquinamento. Le soluzioni tecniche e tecnologiche adottate sono del più alto livello  e garantiscono un alto livello di purificazione delle emissioni aeree e dell’acqua utilizzata nel ciclo produttivo. L'azienda ha sviluppato una serie di programmi per la gestione dei rifiuti di produzione, la maggior parte dei quali viene consegnato per l'utilizzo da parte di altri settori industriali.</p>
          <img v-scroll-reveal.reset class="row-img" src="/static/img/sustainability/environment/env.jpg" alt="">
          <p class="indent">Nel rispetto della propria politica ambientale, l’azienda ha sviluppato ed introdotto un Sistema di Gestione Integrato secondo i requisiti previsti dalla norma EN ISO 14001:2004.</p>
          <!-- <div class="row">
            <div class="row-text">
              <p class="indent">The existing melting furnaces enable the recycling and reuse of aluminium scrap generated in Bulgaria, thus reducing high energy costs and limiting the harmful emissions resulting from the production of primary aluminium.</p>
              <p class="indent">Consistent with its environmental policy, the company has developed and introduced an Integrated Management System in compliance with the requirements of EN ISO 14001.</p>
            </div>
            <div class="row-img" :style="{ backgroundImage : `url(${'/static/img/sustainability/environment/env.jpg'})` }"></div>
          </div> -->
          <p>
            <a href="/static/files/Alcomet-Environmental-Management-Policy-2017-.pdf" target="_blank">Alcomet Environmental Management Policy 2017</a>
          </p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-env-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sustainability-env-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.row {
  display: flex;
  margin: 30px auto;
  width: 80%;
}
.row-text {
  margin-right: 20px;
  width: 33.33%;
}
.row-img {
  border-radius: 6px;
  margin: 20px auto;
  min-height: 1px;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-env {
    padding-bottom: 20px;
  }
  .sustainability-env-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .row-img {
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Environment.vue